import React from "react";
import logo from "../../assets/images/logo.webp";

const styles = {
  wrapper: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "24px",
    backgroundColor: "#faf9f7",
    fontFamily: "inherit",
  },
  logo: {
    width: "160px",
    marginBottom: "32px",
  },
  title: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#222",
    marginBottom: "12px",
  },
  text: {
    fontSize: "16px",
    color: "#555",
    maxWidth: "480px",
    lineHeight: 1.5,
  },
};

export default function Maintenance() {
  return (
    <div style={styles.wrapper}>
      <img src={logo} alt="Casaideas" style={styles.logo} />
      <h1 style={styles.title}>Estamos en mantenimiento</h1>
      <p style={styles.text}>
        Estamos realizando mejoras en nuestro sitio. Volvé a intentarlo en unos
        minutos, ¡gracias por tu paciencia!
      </p>
    </div>
  );
}
